import { ACTION_TYPES, HOME_ROUTES } from './actions'

export const SUGGESTED_STEPS = [
  {
    id: 'invite_learners',
    title: 'Invite your learners',
    icon: 'tabler:users',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.INVITE_LEARNERS },
  },
  {
    id: 'invite_team',
    title: 'Invite your team',
    icon: 'tabler:users-group',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.INVITE_TEAM },
  },
  {
    id: 'learning_path',
    title: 'Build a learning path',
    icon: 'tabler:route',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.LEARNING_PATH },
  },
  {
    id: 'custom_domain',
    title: 'Connect a custom domain',
    icon: 'tabler:world',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.CUSTOM_DOMAIN },
  },
  {
    id: 'integration',
    title: 'Connect an integration',
    icon: 'tabler:plug',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.INTEGRATIONS },
  },
  {
    id: 'certificates',
    title: 'Add certificates & badges',
    icon: 'tabler:certificate',
    action: { type: ACTION_TYPES.ROUTE, to: HOME_ROUTES.CERTIFICATES },
  },
]
